import { JsonObject, JsonProperty } from 'json2typescript';

import { BooleanInverterAdapter } from '../../client/helpers/serializer/adapters/boolean-inverter.adapter';
import { FiscalCountryInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('FiscalCountry')
export class FiscalCountry implements FiscalCountryInterface {
    @JsonProperty('CountryName', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('TINNumber', StringAdapter, true)
    private _TINNumber: string = undefined;

    @JsonProperty('IsTINAvailable', BooleanInverterAdapter, true)
    private _isTINNotAvailable: boolean = undefined;

    @JsonProperty('TINNotAvailableReason', StringAdapter, true)
    private _TINNotAvailableReason: string = undefined;

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get TINNumber(): string {
        return this._TINNumber;
    }

    set TINNumber(value: string) {
        this._TINNumber = value;
    }

    get isTINNotAvailable(): boolean {
        return this._isTINNotAvailable;
    }

    set isTINNotAvailable(value: boolean) {
        this._isTINNotAvailable = value;
        this._TINNumber = undefined;

        if (!this._isTINNotAvailable) {
            this._TINNotAvailableReason = undefined;
        }
    }

    get TINNotAvailableReason(): string {
        return this._TINNotAvailableReason;
    }

    set TINNotAvailableReason(value: string) {
        this._TINNotAvailableReason = value;
    }

    isComplete(): boolean {
        return !!this.name && (this.isTINNotAvailable ? !!this.TINNotAvailableReason : !!this.TINNumber);
    }
}
